import "./styles.css";
import Effect from "./pages/home/page";

export function GreenValeHero() {
  return (
    <div className="special-effect-root" data-special-effect="green-vale">
      <Effect />
    </div>
  );
}

export default GreenValeHero;
